import { getAbsoluteUrl } from 'utils/url';

export const ADMIN_GROUP = 'sso_admin';
export const SUPER_GROUP = 'sso_super';
export const FIELD_FORCE_GROUP = 'sso_field_force';
export const SUPPORT_GROUP = 'sso_support';
export const SALES_GROUP = 'sso_sales';
export const SALES_COORDINATE_GROUP = 'sso_sales_coord';
export const MARKETING_GROUP = 'sso_marketing';
export const DEV_GROUP = 'sso_dev';
export const PUBLIC_GROUP = 'sso_public';
export const PARAMETRIC_GROUP = 'sso_parametric';
export const PROJECTS_GROUP = 'sso_projects';
export const BUSINESS_DEVELOPMENT_GROUP = 'sso_business_development';
export const MARKETING_ADMIN_GROUP = 'sso_marketing_admin';
export const FINANCE_GROUP = 'sso_finances';
export const GL_GROUP = 'sso_gl';

// logouts from microsoft account
export const LOGOUT_URL = getAbsoluteUrl('/_sso/logout');
